import { Formik, Form } from 'formik';
import Submit from 'blocks/Form/fields/Submit';
import Text from 'components/Formik/Text';
import Select from 'components/Formik/Select';
import Checkboxes from 'components/Formik/Checkboxes';
import * as Yup from 'yup';

/* === JAPAN - AR Opt in === */

let initialValues = {
    LastName: '',
    FirstName: '',
    Company: '',
    Specialty__c: '',
    Email: '',
    Title: '',
    consenttoPrivacyPolicy: [],
    Opt_in_for_emails__c: 'Yes',
    MarketoSalesDivisionHVT__c: 'TRUE',
    Country: 'Japan',
    marketingRequested: 'TRUE',
};

const options = [
    {
        label: '循環器内科医',
        value: '循環器内科医',
    },
    {
        label: '一般内科医/総合診療科医',
        value: '一般内科医/総合診療科医',
    },
    {
        label: '心臓外科医',
        value: '心臓外科医',
    },
    {
        label: '上記以外の医師',
        value: '上記以外の医師',
    },
    {
        label: '臨床検査技師',
        value: '臨床検査技師',
    },
    {
        label: '診療放射線技師',
        value: '診療放射線技師',
    },
];

const privacy = [
    {
        label: '個人情報の取り扱いについて同意する場合はチェックを入れて 「送信」をクリックしてください。',
        value: 'TRUE',
    },
];

const required = 'この項目は必須です'; // This field is required

const validation = Yup.object({
    LastName: Yup.string().required(required),
    FirstName: Yup.string().required(required),
    Company: Yup.string().required(required),
    Specialty__c: Yup.string(),
    Email: Yup.string()
        .email('有効なメールアドレスを入力してください') // Please provide a valid email address
        .required(required),
    Title: Yup.string().required(required),
    consenttoPrivacyPolicy: Yup.array().min(1, required),
});

const Form21133 = ({ handleSubmit, isPending, language }) => {
    return (
        <>
            <Formik
                initialValues={initialValues}
                onSubmit={(values) => handleSubmit('marketo', values)}
                validationSchema={validation}
            >
                {(formik) => (
                    <Form className="form form--lg">
                        <div className="grid-lg-2 row-gap-0">
                            <Text label="お名前（姓）- 必須" name="LastName" />
                            <Text
                                label="お名前（名） - 必須​"
                                name="FirstName"
                            />
                            <Text
                                label="ご施設名（病院名）- 必須"
                                name="Company"
                            />
                            <Text label="所属部署" name="Specialty__c" />
                            <Select
                                label="専門領域・資格 - 必須"
                                name="Title"
                                options={options}
                                placeholder="選択してください…"
                            />
                            <Text label="メールアドレス- 必須" name="Email" />
                        </div>
                        <p className="small">
                            ご記入いただいた個人情報は、弊社製品・サービスの紹介、並びに弊社製品・サービスに関連する、安全性・有効性・品質・適正使用に関する情報、診断・治療に関する情報、医療情報・学術情報および学会・セミナー情報、および販売促進に関する情報の収集・分析・提供を目的として利用いたします。なお、個人情報は、弊社の
                            <a href="/jp/legal/privacy-policy">
                                プライバシーポリシー
                            </a>
                            に基づき、適切に管理いたします。
                        </p>

                        <Checkboxes
                            options={privacy}
                            name="consenttoPrivacyPolicy"
                        />
                        <Submit
                            formik={formik}
                            isPending={isPending}
                            pendingText={'送信'}
                            validation="すべての項目を入力してください" // Please fill in all required fields
                        >
                            送信
                        </Submit>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default Form21133;
